import request from '@/utils/request'
import qs from 'qs'

// 获取产品详情
export function xcApplyByChannelId(params) {
    return request({
        url: 'api/xcApplyByChannelId/' + "?" + qs.stringify(params, { indices: false }),
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/applyCenter.js